module.exports = __webpack_public_path__ + "static/media/store.77bf2f6e.jpg";